<template>
    <b-container class="admin-reset-password-init">
        <b-row class="reset-password-title-init">
            <b-col>{{$t('reset_password.title')}}</b-col>
        </b-row>
        <b-row>
            <b-col lg="6">
                <b-form-input v-model="email"
                              :placeholder="$t('reset_password.email')"
                              autocomplete="username">
                </b-form-input>
            </b-col>
        </b-row>
        <b-row>
            <b-col lg="3">
                <b-button @click="resetPassword" variant="primary" class="reset-password-btn">{{$t('reset_password.title')}}</b-button>
            </b-col>
        </b-row>

        <b-modal id="resetInitSuccessModal"
                 hide-header
                 hide-footer
                 no-close-on-backdrop
                 no-close-on-esc>
            <b-container class="reset-success-container">
                <b-row>
                    <b-col class="reset-success-icon">
                        <font-awesome-icon :icon="['far', 'envelope']"></font-awesome-icon>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col class="reset-success-title">
                        {{$t('reset_password_init.modal_title')}}
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        {{$t('reset_password_init.modal_content')}}
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <b-button class="reset-success-close-btn"
                                  @click="$bvModal.hide('resetInitSuccessModal')">{{$t('close')}}
                        </b-button>
                    </b-col>
                </b-row>
            </b-container>
        </b-modal>
    </b-container>
</template>

<script>
    import {library} from '@fortawesome/fontawesome-svg-core'
    import {faEnvelope} from '@fortawesome/free-regular-svg-icons'

    library.add(faEnvelope);

    export default {
        name: 'AdminResetPassword',
        components: {},
        data() {
            return {
                email: '',
            };
        },
        methods: {
            resetPassword() {
                this.$callAPI('hkiarace/admin/reset_password_init/', {email: this.email}, function (response) {
                    this.$bvModal.show("resetInitSuccessModal");
                });
            },
        }
    }
</script>

<style lang="less">
    .admin-reset-password-init {
        text-align: left;
        padding: 24px;

        .reset-password-init-title {
            font-weight: bold;
            font-size: 1.3rem;
        }

        .row {
            margin-bottom: 1rem;
        }

        .form-control {
            border-radius: 0;
            border: none;
            border-bottom: 1px solid #ced4da;
        }

        .reset-password-btn {
            width: 100%;
            background-color: #3b3a53;
            border-color: #3b3a53;
            color: white;
            font-weight: bold;
        }

        .forgot-pw-link {
            color: #798188;
        }
    }

    #resetInitSuccessModal {
        text-align: center;

        .reset-success-container {
            padding-top: 48px;
            font-size: 1.5rem;

            .row {
                margin-bottom: 2rem;
            }

            .reset-success-icon {
                font-size: 5rem;
            }

            .reset-success-title {
                font-weight: bold;
                font-size: 2.5rem;
            }

            .reset-success-close-btn {
                background-color: black;
                border-radius: 0;
                width: 100%;
                font-size: 1.5rem;
            }
        }
    }
</style>